module.exports = __webpack_public_path__ + "static/img/16.4d1a271.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/16.jpeg
// module id = hZZP
// module chunks = 0